import { render, staticRenderFns } from "./PermissionSelector.vue?vue&type=template&id=2f1a5b9d&"
import script from "./PermissionSelector.vue?vue&type=script&lang=js&"
export * from "./PermissionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports